// extracted by mini-css-extract-plugin
module.exports = {"responsive-video":"WistiaEmbed-module__responsive-video___GGlON"};